<ng-container *ngIf="{ billings: billings$ | async } as vm">
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-title>Datos de facturación</ion-title>
      <ion-buttons slot="start">
        <ion-button (click)="back()">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button (click)="addBillingInfo()">
          <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-refresher (ionRefresh)="doRefresh($event)" slot="fixed" #ionRefresher>
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <div>
      <ion-list lines="none" *ngIf="!vm.billings?.data && loadingBillings">
        <ion-item *ngFor="let invoice of [0, 1, 2, 3, 4]">
          <ion-row>
            <ion-col size="12">
              <h4>
                <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
              </h4>
              <p class="date">
                <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
              </p>
            </ion-col>
          </ion-row>
        </ion-item>
      </ion-list>
      <h4 *ngIf="vm.billings?.data.length && !loadingBillings">Seleccionar datos de facturación:</h4>
      <ion-list lines="none">
        <ion-item *ngIf="vm.billings?.data.length === 0 && !loadingBillings">
          <ion-label>
            <h2>No tienes datos de facturación.</h2>
          </ion-label>
        </ion-item>
        <ion-item
          *ngFor="let item of vm.billings?.data"
          (click)="selectBilling(item)"
          [class.selected-billing]="selectedBilling?.id === item.id"
        >
          <ion-label>
            <ion-row>
              <ion-col size="12">
                <h2>{{ item.name }}</h2>
                <p>{{ item.rfc }}</p>
              </ion-col>
            </ion-row>
          </ion-label>
          <div class="p-ultra" slot="end">
            <b>
              <ion-icon name="create-outline" (click)="addBillingInfo(item, $event)"></ion-icon>
            </b>
            <b>
              <ion-icon name="trash-outline" (click)="deleteBillingInfo(item, $event)"></ion-icon>
            </b>
          </div>
        </ion-item>
      </ion-list>
    </div>
    <ion-infinite-scroll (ionInfinite)="doInfinite($event, vm.billings)">
      <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Cargando..."></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-content>
  <ion-footer>
    <ion-toolbar>
      <ion-button expand="block" [disabled]="!selectedBilling" (click)="confirmSelection()">Confirmar</ion-button>
    </ion-toolbar>
  </ion-footer>
</ng-container>
